/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getReferralCodeV1ResponseDataSchema = z.object({
  code: z.string(),
});

export type IGetReferralCodeV1ResponseData = z.infer<typeof getReferralCodeV1ResponseDataSchema>;

export const getReferralCodeV1ResponseSchema = createApiResponseSchema(
  getReferralCodeV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReferralCodeV1ResponseData>>;

export type IGetReferralCodeV1Response = IAPI<IGetReferralCodeV1ResponseData>;
